module.exports = __webpack_public_path__ + "static/img/1.47ce994.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/1.png
// module id = HjS6
// module chunks = 0